import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
export const AUTH_STORAGE_KEY = 'swipewish.auth';

if (!url || !anonKey) {
  console.error(
    'SwipeWish: VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY non sono impostate. ' +
      'Copia .env.example in .env e compila i valori.'
  );
}

// createBrowserClient from @supabase/ssr silently overrides any custom storage
// with its own cookie-based adapter, breaking hydrateSession() (which reads localStorage)
// and making sessions unavailable for PostgREST JWT attachment.
// Using createClient from @supabase/supabase-js respects the storage option.
const localStorageAdapter = {
  getItem: (key: string): string | null => {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(key);
  },
  setItem: (key: string, value: string): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(key, value);
  },
  removeItem: (key: string): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(key);
  },
};

export const supabase: SupabaseClient = createClient(
  url ?? 'http://localhost:54321',
  anonKey ?? 'public-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: AUTH_STORAGE_KEY,
      storage: localStorageAdapter,
    },
    realtime: {
      params: { eventsPerSecond: 10 },
    },
    global: {
      headers: { 'x-client-info': 'swipewish-mobile' },
    },
  }
);
